import React from 'react';
import { useState } from 'react';
import { apiKey } from './Constant';

const Weather = ( {onCityFound} ) => {

    const [city, setCity] = useState('');

    const getCity = (city) => {
        console.log(city);
        const url = `https://api.openweathermap.org/data/2.5/forecast?q=${city}&cnt=5&appid=${apiKey}`
        fetch(url)
        .then(response => response.json())
        .then(response => onCityFound({
            city: response.city.name,
            CountryName: response.city.country
        }))
    };

    return (
        <div className="pra ml-5">
            {/* <h1 className='container LOGOTXT'>5 Day Forcasts</h1> */}
            <input
    
                placeholder='Search City & watch Weather'
                value={city} 
                onChange={e => setCity(e.target.value)} 
            />
            <button className="btn btn-success m-2"onClick={ () => getCity(city)}>Search</button>
        </div>
    );
};

export default Weather;